export const AUTO_GENERATED_DESCRIPTION_TYPE_IDS = [9070, 9065];
export enum UNORDERD_LIST_TYPE {
  'FABID' = 9073,
}
export const LONG_DESCRIPTION_TYPE_ID = 9065;
